import { TopBar } from '../../top-bar/TopBar';
import { Footer } from '../../footer/Footer';
import { PublicOptions } from '../../../data/publicOptions';
import { About } from '../about/About';
import './Home.css';
import { memo, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {Sponsors} from "./Sponsors";
import Flyer from '../../../assets/Energy Storage Discussions (80 x 20 in).svg';

const HomeWrapper = memo(() => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const access_token = localStorage.getItem('access_token');

  useEffect(() => {
    if (hash) {
      console.log('Getting token');
      console.log(hash.substring(1));
      const pairs = hash.substring(1).split('&');
      const result = {};

      pairs.forEach((pair) => {
        const [key, value] = pair.split('=');
        result[key] = decodeURIComponent(value);
      });

      localStorage.setItem('id_token', result['id_token']);
      localStorage.setItem('access_token', result['access_token']);
      localStorage.setItem('expires_in', result['expires_in']);
      localStorage.setItem('token_type', result['token_type']);

      navigate('/home');
    }
  }, []);

  useEffect(() => {
    if (access_token) {
      navigate('/home');
    }
  }, []);

  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v5.0';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
      <>
        <TopBar options={PublicOptions} />
        <div className="content">
          <div className="banner-wrapper">
            <a href="https://nnsymposium.auth.us-west-1.amazoncognito.com/login?client_id=2rghd4qrs6co16oh5e3t685km3&response_type=token&scope=email+openid+phone+profile&redirect_uri=https://esd2025.reddealmacenamientodeenergia.com">
              <img src={Flyer}/>
            </a>
          </div>
          <div className="home-top-wrapper">
            <h1 className="title-top">
              Energy Storage Discussions 2025
            </h1>
            <p className="title-top-text">
              This year, the Energy Storage Discussions 2025 will take place at the Museo de Ciencias Caracol in
              Ensenada, Baja California, in <strong className="date-symposium">November 19 - 21, 2025</strong>.
            </p>
            <p className="title-top-text">
              The event will feature:
              <li>Plenary Speakers – Renowned experts in energy storage.</li>
              <li>Keynote Speakers – Leading researchers presenting cutting-edge advancements.</li>
              <li>Poster Sessions – Contributions from researchers and students showcasing their work.</li>
              <li>Workshops – Hands-on sessions covering advanced techniques and emerging topics in energy storage.</li>
            </p>
          </div>
          <Sponsors/>
          <div className="snn-page-section">
            <section>
              <h2 className="snn-title">Topics of Interest</h2>
              <p className="snn-justify">
                The conference will cover, but is not limited to, the following topics:
              </p>
              <ul>
                <li>
                  Battery concepts, materials, and characterization:
                  <ul>
                    <li>Li-ion, Li-sulfur, Na-, Mg-, Zn-ion, Ni-Cd, Lead-acid, Metal-air, and other emerging
                      technologies.
                    </li>
                  </ul>
                </li>
                <li>Capacitor concepts, materials, and characterization.</li>
                <li>
                  Alternative energy storage technologies:
                  <ul>
                    <li>Flywheels, pumped hydro, compressed air, etc.</li>
                  </ul>
                </li>
                <li>
                  Modeling of energy storage systems:
                  <ul>
                    <li>Quantum mechanical modeling, multiscale modeling, molecular dynamics, etc.</li>
                  </ul>
                </li>
                <li>
                  Energy storage applications in automotive, mobile, and stationary systems:
                  <ul>
                    <li>Control, cooling, mechanical systems, lifetime and safety testing, and mass production.</li>
                  </ul>
                </li>
                <li>Recycling and sustainability in energy storage.</li>
              </ul>
              <p className="snn-justify">
                Join us in Ensenada, Mexico, for an exciting edition of Energy Storage Discussions 2025!
              </p>
            </section>
          </div>
          <About/>
        </div>
        <Footer/>
      </>
  );
});
HomeWrapper.displayName = 'HomeWrapper';
export default HomeWrapper;
